import { AppApiRootList, AppEnvironment } from 'app/app-config/app-config.model';

/**
 * production is the default and is used in the app-bootstrap-factory as the default,
 * so it needs to be exposed separately.
 */
export const quotingProdApiHost = 'https://app.kin.insure';
export const quotingProdApiRoot = `${quotingProdApiHost}/api/v1`;
export const quotingPlatformProdApiHost = 'https://app.kin.insure';
export const quotingPlatformProdApiRoot = `${quotingPlatformProdApiHost}/api/v1/shim`;
export const opportunitiesProdApiRoot = 'https://app.kin.insure/opportunities';
export const intakeProdApiRoot = 'https://app.kin.insure/intake';
export const regalDialerProdApiRoot = 'https://app.kin.insure/regal_dialer';

export const quotingAppApiConfig: ReadonlyMap<AppEnvironment, AppApiRootList> = new Map([
  [
    'local',
    {
      quoteV1: 'https://app.kin.haus/api/v1',
      quotingPlatform: 'https://app.kin.haus/api/v1/shim',
      opportunities: 'http://localhost:3000/opportunities',
      intake: 'http://localhost:3000/intake',
      regalDialer: 'http://localhost:3000/regal_dialer',
    },
  ],
  [
    'development',
    {
      quoteV1: 'https://rift-pr-42309-app.dev.kin.co/api/v1',
      quotingPlatform: 'https://rift-pr-42309-app.dev.kin.co/api/v1/shim',
      opportunities: 'https://rift-pr-42309-app.dev.kin.co/opportunities',
      intake: 'https://rift-pr-42309-app.dev.kin.co/intake',
      regalDialer: 'https://rift-pr-42309-app.dev.kin.co/regal_dialer',
    },
  ],
  [
    'staging',
    {
      quoteV1: 'https://app.kin.haus/api/v1',
      quotingPlatform: 'https://app.kin.haus/api/v1/shim',
      opportunities: 'https://app.kin.haus/opportunities',
      intake: 'https://app.kin.haus/intake',
      regalDialer: 'https://app.kin.haus/regal_dialer',
    },
  ],
  [
    'production',
    {
      quoteV1: quotingProdApiRoot,
      quotingPlatform: quotingPlatformProdApiRoot,
      opportunities: opportunitiesProdApiRoot,
      intake: intakeProdApiRoot,
      regalDialer: regalDialerProdApiRoot,
    },
  ],
]);
